// extracted by mini-css-extract-plugin
module.exports = {"left":"_2bq28m","center":"_2UFN1Z","right":"_3RHgeA"};